import styles from 'components/header/header.module.css';
import { NavLink, useLocation } from 'react-router-dom';

import { LogoBeige } from 'components/vectors/LogoBeige';
import { LangSwitcher } from 'components/langSwitcher/LangSwitcher';
import { BurgerMenu } from 'components/burgerMenu/BurgerMenu';
import { SocialIcons } from 'components/socialIcons/SocialIcons';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BEIGE, DARK_BLACK, TRANSPARENT } from 'constants/shared';
import { LogoBlack } from 'components/vectors/LogoBlack';
import { GALLERY_URL, HOME_URL } from 'constants/navigation';

export const Header = ({ openClosePopup }: { openClosePopup: () => void }) => {
    const { t } = useTranslation();
    const windowHeight = window.innerHeight - 100;

    const [logo, setLogo] = useState(<LogoBeige />);
    const [headerBg, setHeaderBg] = useState(TRANSPARENT);

    const location = useLocation();
    const isMainPage = /^\/?$/.test(location.pathname);

    const isGalleryPage = location.pathname.endsWith(GALLERY_URL);
    const isMainColor = isGalleryPage ? DARK_BLACK : BEIGE;

    useEffect(() => {
        if (isGalleryPage) {
            setLogo(<LogoBlack />);
            setHeaderBg(BEIGE);
        } else {
            setLogo(<LogoBeige />);
            setHeaderBg(TRANSPARENT);
        }
    }, [isGalleryPage]);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const shouldColorInBlack =
                scrollPosition > windowHeight && !isGalleryPage;

            if (shouldColorInBlack) {
                setHeaderBg(DARK_BLACK);
            } else if (isGalleryPage) {
                setLogo(<LogoBlack />);
                setHeaderBg(BEIGE);
            } else {
                setHeaderBg(TRANSPARENT);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isGalleryPage, windowHeight]);

    return (
        <header
            className={styles.header}
            style={{
                backgroundColor: headerBg,
                transition: 'background-color 0.3s ease-in-out',
            }}
        >
            <div className={styles.header__actionsLeft}>
                <BurgerMenu isMainColor={isMainColor} />

                <button
                    className={styles.header__BookBtn}
                    onClick={openClosePopup}
                    style={{ color: isMainColor }}
                >
                    {t('contactFormBookEvent.bookNow')}
                </button>
            </div>

            <NavLink
                to={HOME_URL}
                className={`${styles.logo} ${isMainPage ? styles.animated : null}`}
            >
                {logo}
            </NavLink>

            <div className={styles.header__actionsRight}>
                <LangSwitcher isBlack={isGalleryPage} />
                <div className={styles.actionRight__burgerMenu}>
                    <BurgerMenu isMainColor={isMainColor} />
                </div>
                <div className={styles.actionsRight__socialIcons}>
                    <SocialIcons isBlack={isGalleryPage} />
                </div>
            </div>
        </header>
    );
};
